import React, { useEffect, useState } from 'react';
import { Button, Toggle } from '@usitsdasdesign/dds-react';
import RenderFields from 'molecules/RenderFields';
import SearchableSelect from 'molecules/SearchableSelect';
import { customShiftOption, CustomSingleValue } from 'helper/shift-timings/helper-function';
import { useForm } from 'react-hook-form';

const CallSupport = ({
    className = '',
    shiftMasterData,
    handleCallSupportSubmit,
    defaultValues
}) => {
    const [checked, setChecked] = useState(defaultValues?.isOnCallSupport ?? false);
    const clearOnCallSupportValues = () => {
        setValue('callSupportType', null);
        setValue('onCallSupportShiftTime', null);
    }
    const {
        register,
        handleSubmit,
        control,
        setValue,
        getValues,
        formState: { errors },
        watch,
        reset
    } = useForm({ defaultValues });

    const fields = [
        {
            id: 2,
            type: 'radio-group',
            name: 'callSupportType',
            title: '',
            placeholder: '',
            isRequired: true,
            direction: 'row',
            radiobuttonItems: [
                {
                    value: 'full_day',
                    label: 'Full day',
                    isActive: watch('callSupportType') === 'full_day',
                    isDisabled: false
                },
                {
                    value: 'half_day',
                    label: 'Half day',
                    isActive: watch('callSupportType') === 'half_day',
                    isDisabled: false
                }
            ]
        },
    ];
    useEffect(() => {
        setChecked(defaultValues?.isOnCallSupport ?? false)
    }, [defaultValues]);


    return (
        <div className={className}>
            <div className={`mt-4 `}>
                <RenderFields
                    fields={fields}
                    control={control}
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    watch={watch}
                    gap='gap-4'
                    grid='border border-gray-200 py-2.5 px-3 mb-4'
                />

                <SearchableSelect
                    id="onCallSupportShiftTime"
                    className='time-custom-select'
                    name="onCallSupportShiftTime"
                    label="OCS Shift time"
                    placeholder="Select Shift timings"
                    isRequired={true}
                    options={shiftMasterData}
                    control={control}
                    register={register}
                    ignoreTextColor={true}
                    components={{ Option: customShiftOption, SingleValue: CustomSingleValue }}
                />

                <div className='flex justify-end gap-4 my-6'>
                    <Button kind='silent' label='Clear All' onClick={clearOnCallSupportValues}
                        isDisabled={false}
                    />
                    <Button kind='primaryLoud' label='Save' onClick={() => handleCallSupportSubmit({ ...watch(), isOnCallSupport: checked })}
                        isDisabled={checked ? (!watch('callSupportType') || !watch('onCallSupportShiftTime')) : false}
                    />
                </div>
            </div>
        </div>
    );
};

export default CallSupport;
